import * as actionTypes from '../actions/funder';

const initialState = {
  ratingCategories: []
};

const funderReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_RATING_CATEGORIES_SUCCESS: {
      const ratingCategories = action.payload.map(cat => {
        const {
          id,
          attributes: { name, options }
        } = cat;
        return { id: parseInt(id, 10), name, options };
      });
      return {
        ...state,
        ratingCategories
      };
    }
    default: {
      return state;
    }
  }
};

export default funderReducer;
